{
	"aboutAIStyle": "About AI Style",
	"addFinalEditsToAIStyle": "Add Final Edits to AI Style",
	"adjustProjectDate": "Adjust Project Date",
	"ariaAboutCurrentAiStyle": "About Current AI Style",
	"ariaAddCurrentEditsToAiStyle": "Add Current Edits To AI Style",
	"ariaChangeProjectDate": "Change Project Date",
	"ariaCurrentAiStyleMenu": "Current AI Style Menu",
	"ariaDeleteProject": "Delete Project",
	"ariaExitSetup": "Exit Setup",
	"ariaExpandPhotoSearch": "Expand Photo Search",
	"ariaExportMenu": "Export Menu",
	"ariaExportPhotosLocally": "Export Photos Locally",
	"ariaFinishSetup": "Finish Setup",
	"ariaFitToWindow": "Fit To Window",
	"ariaGoBackToProjectsList": "Go Back To Projects List",
	"ariaManualEditing": "Manual Editing",
	"ariaOpenAiStyleReferences": "Open AI Style References",
	"ariaOpenFocusView": "Open Focus View",
	"ariaOpenGallery": "Open Gallery",
	"ariaOpenPhotoCompare": "Open Photo Compare",
	"ariaPhotoZoomControls": "Photo Zoom Controls",
	"ariaProjectMenu": "Project Menu",
	"ariaPublishPhotosToPixieset": "Publish Photos To Pixieset",
	"ariaReapplyAiStyle": "Reapply AI Style",
	"ariaRenameProject": "Rename Project",
	"ariaResetProject": "Reset Project",
	"ariaSelectPhotoZoomLevel": "Select Photo Zoom Level",
	"ariaSwitchToAiEditing": "Switch To AI Editing",
	"ariaSwitchToAiEditingMenu": "Switch To AI Editing Menu",
	"ariaSwitchToCulling": "Switch To Culling",
	"ariaSwitchToDifferentAiStyle": "Switch To Different AI Style",
	"ariaSwitchToEditing": "Switch To Editing",
	"ariaSwitchToManualEditing": "Switch To Manual Editing",
	"ariaToggleBeforeAndAfterView": "Toggle Before And After View",
	"ariaTopToolbar": "Top Toolbar",
	"ariaZoomTo100": "Zoom To 100%",
	"cullPhotos": "Cull Photos",
	"deleteProject": "Delete Project",
	"dialogExitSetupMessage": "You can come back later at any time to continue to set up your AI Style.",
	"dialogExitSetupPrimary": "Exit Setup",
	"dialogExitSetupSecondary": "Choose a Different Style",
	"dialogExitSetupTitle": "Are you sure you want to exit the setup?",
	"dialogReapplyMessage": "This will re-apply the AI Style and remove all temporary references and locked edits. This action can not be undone.",
	"dialogReapplyPrimary": "Reapply",
	"dialogReapplyTitle": "Reapply AI Style",
	"dialogReferencesMessage": "The AI result could be sub-optimal without sufficient references.",
	"dialogReferencesPrimary": "Continue Anyway",
	"dialogReferencesTitle": "You have not marked all the references.",
	"dialogSwitchMessage": "Switching to a different Edit Mode will reset the current project. This will remove the edit history and overwrite the catalog (.catalog file) in the project folder. This can not be undone.",
	"dialogSwitchPrimary": "Switch",
	"dialogSwitchStyleMessage": "Switching to a different AI Style will reset the current project. This will remove the edit history and overwrite the catalog (.catalog file) in the project folder. This can not be undone.",
	"dialogSwitchStyleTitle": "Switch AI Style",
	"dialogSwitchTitle": "Switch to Manual Editing",
	"editPhotos": "Edit Photos",
	"errorAutoExposureWithEdits": "Cannot apply Auto Exposure on top of existing edits",
	"errorLoadAccount": "Could not load your account. Please try again.",
	"errorLoadAiStyle": "Failed to load AI Style. Please try again.",
	"exportPhotos": "Export Photos",
	"exportToLocal": "Export to Local",
	"fetchingAiStyleInfo": "Fetching latest AI Style info...",
	"finishAiStyleSetup": "Finish AI Style Setup",
	"fit": "Fit",
	"placeholderSearchByFilename": "Search photos by filename...",
	"publishToPixieset": "Publish to Pixieset",
	"reapplyAIStyle": "Reapply AI Style",
	"renameProject": "Rename Project",
	"resetProject": "Reset Project",
	"sampleProject": "Sample Project",
	"switchToAIStyle": "Switch to an AI Style",
	"switchToManualEditing": "Switch to Manual Editing",
	"toastEditsReset": "Edits have been reset.",
	"toastRatingsReset": "Ratings have been reset.",
	"tooltipAutoExposure": "Press and hold to view with Auto Exposure (E)",
	"tooltipBeforeAfter": "Before/After (\\)",
	"tooltipCompare": "Compare (C)",
	"tooltipCullingFinish": "Finish Culling",
	"tooltipCullingFinishMain": "Complete your cull and begin editing your selected photos.",
	"tooltipFocus": "Focus (D)",
	"tooltipGallery": "Gallery (G)",
	"tooltipSearchPhotos": "Search photos",
	"tooltipStyleSettings": "AI Style Settings",
	"tooltipStyleSettingsMain": "Manage your AI Style and editing settings.",
	"useDifferentAIStyle": "Use a different AI Style",
	"viewReferences": "View References"
}
